import Vue from 'vue'
import Vuex from 'vuex'
import confirmMessage from './store/confirm-message'
import condominiums from './store/condominiums'
import documents from './store/documents'
import docsReports from './store/docsReports'
import formRules from './store/form-rules'
import request from './store/request'
import maskMoney from './store/mask-money'
import permissions from './store/permissions'
import dashboard from './store/dashboard'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    condominiums,
    documents,
    docsReports,
    confirmMessage,
    maskMoney,
    formRules,
    permissions,
    request,
    dashboard
  },
  state: {
    modulesAvaliable: null,
    theme: {
      primaryColor: '',
      background: ''
    },
    idServiceProvider: '',
    permissionsUser: {},
    config: {
      logo: {
        src: '',
        title: 'InSight Síndicos'
      }
    },
    userLoged: {},
    loader: {
      loaderOn: false,
      linearLoader: true,
      circleLoader: false
    },
    snack: {
      snackbarShow: false,
      snackMessage: '',
      timeout: null,
      typeSnack: ''
    }
  },
  actions: {

  },
  mutations: {
    updateModulesAvaliable (state, modules) {
      modules ? state.modulesAvaliable = { ...modules } : state.modulesAvaliable = null
    },

    setNewThemeSystem (state, newTheme) {
      if (newTheme.color) {
        state.theme.primaryColor = newTheme.color
      }
      if (newTheme.logo) {
        state.config.logo.src = newTheme.logo
      }
      if (newTheme.bg) {
        state.theme.background = newTheme.bg
      }
    },

    newServiceProvider (state, id) {
      state.idServiceProvider = id
    },

    updateUserLoged (state, obj) {
      state.userLoged = obj
    },

    showLoader (state, opts) {
      if (opts && opts.circle) {
        state.loader.linearLoader = false
        state.loader.circleLoader = true
      } else {
        state.loader.linearLoader = true
        state.loader.circleLoader = false
      }
      state.loader.loaderOn = true
    },

    hideLoader (state) {
      state.loader.loaderOn = false
    },

    showAlert (state, opts) {
      state.snack.snackbarShow = true
      state.snack.snackMessage = opts.message
      state.snack.timeout = opts.time
      state.snack.typeSnack = opts.type
    }
  }
})
